<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-swap-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Articles ayant subi un mouvement de stock</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">


                                <div class=" xl:col-span-12  col-span-12 mt-4 mb-4">
                                    <input v-model="searchword" class="form-control form-control-lg w-full custom-placeholder" type="text"
                                           placeholder="Rechercher un article"
                                           aria-label=".form-control-lg example">
                                </div>

                                <div class="xl:col-span-4  col-span-12 mt-4 mb-4">
                                    <select @change="load" v-model="searchtypemouvement" style=" display: inline-block; margin: 0 5px; padding: 2px 25px;
                                            border: 1px solid #aaa; border-radius: 3px;"
                                            class="tabulator-page-size w-full"
                                            title="Type de mouvement">
                                        <option value="">Tous les types de mouvement</option>
                                        <option value="ME">Mouvements d'entrée</option>
                                        <option value="MS">Mouvements de sortie</option>
                                        <option value="MI">Mouvements d'inventaire</option>
                                        <option value="MT">Transferts entre magasins</option>
                                    </select>
                                </div>

                                <div class="xl:col-span-4  col-span-12 mt-4 mb-4">
                                    <input @change="load" class="form-control w-full" type="date" v-model="datedebut" placeholder="Date début">
                                </div>
                                <div class="xl:col-span-4  col-span-12 mt-4 mb-4">
                                    <input @change="load" class="form-control w-full" type="date" v-model="datefin" placeholder="Date fin">
                                </div>



                            </div>


                            <div class="w-full flex grid-cols-2">

                                <div class="box-title mb-2 sm:mb-0"></div>

                                <div class="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">

                                    <div class="grid lg:grid-cols-5 gap-6">

                                        <div class="space-y-2 cf-colmenu-wrap">
                                            <button type="button" @click="showcolmenu=!showcolmenu" class="ti-btn ti-btn-secondary-full w-full"><i class="ri-layout-column-line"></i> Colonnes</button>
                                            <div v-if="showcolmenu" class="cf-colmenu">
                                                <div class="cf-colmenu-title">Afficher / masquer</div>
                                                <template v-if="activetab==='detail'">
                                                    <label v-for="col in detailcols" :key="col.key" class="cf-colmenu-item">
                                                        <input type="checkbox" class="cf-check" v-model="vcol[col.key]"> <span>{{ col.label }}</span>
                                                    </label>
                                                </template>
                                                <template v-else>
                                                    <label v-for="col in globalcols" :key="col.key" class="cf-colmenu-item">
                                                        <input type="checkbox" class="cf-check" v-model="vcolg[col.key]"> <span>{{ col.label }}</span>
                                                    </label>
                                                </template>
                                            </div>
                                        </div>

                                        <div class=" space-y-2">

                                            <select v-model="DefaultperPage" style=" display: inline-block; margin: 0 5px; border: 1px solid #aaa; border-radius: 3px;" class="tabulator-page-size form-control w-full" aria-label="Page Size" title="Affichage">
                                                <option value="500">500</option>
                                                <option value="700">700</option>
                                                <option value="1000">1000</option>
                                                <option value="1500">1500</option>
                                                <option value="3000">3000</option>
                                                <option value="4000">4000</option>

                                            </select>
                                        </div>

                                        <div class="space-y-2">

                                            <div class="space-y-2">
                                                <select  v-model="taillemodel" class="form-control mb-3 w-full">
                                                    <option value="A4">Portait</option>
                                                    <option value="A4landscape">Paysage</option>
                                                </select>


                                            </div>
                                        </div>
                                        <div class="space-y-2">

                                            <button @click="ExportExcel('xlsx','ARTICLES PAR MOUVEMENT DE STOCK')" class="ti-btn ti-btn-success-full w-full"><i class="ri-file-excel-fill"></i> Exporter en excel</button>

                                        </div>

                                        <div class="space-y-2">
                                            <button @click="print4" class="ti-btn ti-btn-primary-full w-full"><i class="ri-printer-fill"></i> Aperçu avant impression</button>

                                        </div>


                                    </div>


                                </div>
                            </div>




                        </div>

                        <div class="cf-tabs">
                            <button type="button" class="cf-tab" :class="{ 'cf-tab--on': activetab === 'detail' }" @click="activetab='detail'">
                                <i class="ri-list-check-2"></i> Détail
                            </button>
                            <button type="button" class="cf-tab" :class="{ 'cf-tab--on': activetab === 'global' }" @click="activetab='global'">
                                <i class="ri-stack-line"></i> Global
                            </button>
                        </div>

                                    <div v-if="activetab==='detail'" class="box-body !p-0 mybodyheight500px">
                                        <div class="table-responsive">
                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                        <table ref="exportable_tabledetail" class="relative w-full border table table-bordered mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th v-if="vcol.docdate" scope="col" class="th text-start">DATE</th>
                                                <th v-if="vcol.typdoc" scope="col" class="th text-start">TYPE MOUVEMENT</th>
                                                <th v-if="vcol.docref" scope="col" class="th text-start">N°DOC</th>
                                                <th v-if="vcol.libelle" scope="col" class="th text-start">ARTICLE</th>
                                                <th v-if="vcol.stck_init" scope="col" class="th text-start">STOCK AVANT</th>
                                                <th v-if="vcol.qtite" scope="col" class="th text-start">QTE </th>
                                                <th v-if="vcol.sctk_final" scope="col" class="th text-start">STOCK APRES</th>
                                                <th v-if="vcol.pachat" scope="col" class="th text-start">PRIX ACHAT</th>
                                                <th v-if="vcol.pvente" scope="col" class="th text-start">PU</th>
                                                <th v-if="vcol.mtachat" scope="col" class="th text-start">MONTANT ACHAT</th>
                                                <th v-if="vcol.mtvente" scope="col" class="th text-start">MONTANT VENTE</th>
                                                <th v-if="vcol.marge" scope="col" class="th text-start">MARGE</th>
                                                <th v-if="vcol.saisiepar" scope="col" class="th text-start">SAISI PAR</th>
                                                <th v-if="vcol.enregistrele" scope="col" class="th text-start">ENREGISTRÉ LE</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">

                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                   <td v-if="vcol.docdate"  data-label="DATE  : "   >{{ datavalue.docdate }}</td>
                                                   <td v-if="vcol.typdoc"  data-label="TYPE MOUVEMENT  : "   >{{ typeLabel(datavalue.typdoc) }}</td>
                                                   <td v-if="vcol.docref"  data-label="N°DOC  : "   >{{ datavalue.docref }}</td>
                                                   <td v-if="vcol.libelle"  data-label="ARTICLE  : "   >{{ datavalue.libelle }}</td>
                                                   <td v-if="vcol.stck_init" class="text-center" style="text-align: center"  data-label="STOCK AVANT : "   >{{ datavalue.stck_init }}</td>
                                                   <td v-if="vcol.qtite" class="text-center" style="text-align: center"  data-label="QTE : "   >{{ datavalue.qtite }}</td>
                                                   <td v-if="vcol.sctk_final" class="text-center" style="text-align: center"  data-label="STOCK APRES : "   >{{ datavalue.sctk_final }}</td>
                                                   <td v-if="vcol.pachat" class="text-center" style="text-align: center"  data-label="PRIX ACHAT : "   >{{ fmt(datavalue.pachat) }}</td>
                                                   <td v-if="vcol.pvente" class="text-center" style="text-align: center"  data-label="PU : "   >{{ fmt(datavalue.pvente) }}</td>
                                                   <td v-if="vcol.mtachat" class="text-center" style="text-align: center"  data-label="MONTANT ACHAT : "   >{{ fmt(datavalue.pachat*datavalue.qtite) }}</td>
                                                   <td v-if="vcol.mtvente" class="text-center" style="text-align: center"  data-label="MONTANT VENTE : "   >{{ fmt(datavalue.pvente*datavalue.qtite) }}</td>
                                                   <td v-if="vcol.marge" class="text-center" style="text-align: center"  data-label="MARGE : "   >{{ fmt((datavalue.pvente-datavalue.pachat)*datavalue.qtite) }}</td>
                                                   <td v-if="vcol.saisiepar"  data-label="SAISI PAR  : "   >{{ datavalue.saisiepar }}</td>
                                                   <td v-if="vcol.enregistrele"  data-label="ENREGISTRÉ LE  : "   >{{ datavalue.enregistrele }}</td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                </tr>

                                            </template>



                                            </tbody>
                                            <tfoot v-if="filterdatatable.length">
                                                <tr class="cf-total-row">
                                                    <td v-if="vcol.docdate"></td>
                                                    <td v-if="vcol.typdoc"></td>
                                                    <td v-if="vcol.docref"></td>
                                                    <td v-if="vcol.libelle"><strong>SOUS-TOTAL</strong></td>
                                                    <td v-if="vcol.stck_init"></td>
                                                    <td v-if="vcol.qtite"></td>
                                                    <td v-if="vcol.sctk_final"></td>
                                                    <td v-if="vcol.pachat"></td>
                                                    <td v-if="vcol.pvente"></td>
                                                    <td v-if="vcol.mtachat" class="text-center" style="text-align:center"><strong>{{ fmt(totaux.mtachat) }}</strong></td>
                                                    <td v-if="vcol.mtvente" class="text-center" style="text-align:center"><strong>{{ fmt(totaux.mtvente) }}</strong></td>
                                                    <td v-if="vcol.marge" class="text-center" style="text-align:center"><strong>{{ fmt(totaux.marge) }}</strong></td>
                                                    <td v-if="vcol.saisiepar"></td>
                                                    <td v-if="vcol.enregistrele"></td>
                                                </tr>
                                            </tfoot>
                                        </table>


                                    </div>
                                </div>

                                    </div>
                                </div>

                        <div v-if="activetab==='global'" class="box-body !p-0 mybodyheight500px">
                            <div class="table-responsive">
                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                        <table ref="exportable_tableglobal" class="relative w-full border table table-bordered mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th v-if="vcolg.libelle" scope="col" class="th text-start">ARTICLE</th>
                                                <th v-if="vcolg.nbmouvements" scope="col" class="th text-start">NB MOUVEMENTS</th>
                                                <th v-if="vcolg.qtite" scope="col" class="th text-start">QTE</th>
                                                <th v-if="vcolg.mtachat" scope="col" class="th text-start">MONTANT ACHAT</th>
                                                <th v-if="vcolg.mtvente" scope="col" class="th text-start">MONTANT VENTE</th>
                                                <th v-if="vcolg.marge" scope="col" class="th text-start">MARGE</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="globaldatatable.length">

                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in globaldatatable" :key="index">

                                                   <td v-if="vcolg.libelle"  data-label="ARTICLE  : "   >{{ datavalue.libelle }}</td>
                                                   <td v-if="vcolg.nbmouvements" class="text-center" style="text-align: center"  data-label="NB MOUVEMENTS : "   >{{ datavalue.nbmouvements }}</td>
                                                   <td v-if="vcolg.qtite" class="text-center" style="text-align: center"  data-label="QTE : "   >{{ datavalue.qtite }}</td>
                                                   <td v-if="vcolg.mtachat" class="text-center" style="text-align: center"  data-label="MONTANT ACHAT : "   >{{ fmt(datavalue.mtachat) }}</td>
                                                   <td v-if="vcolg.mtvente" class="text-center" style="text-align: center"  data-label="MONTANT VENTE : "   >{{ fmt(datavalue.mtvente) }}</td>
                                                   <td v-if="vcolg.marge" class="text-center" style="text-align: center"  data-label="MARGE : "   >{{ fmt(datavalue.marge) }}</td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                </tr>

                                            </template>



                                            </tbody>
                                            <tfoot v-if="globaldatatable.length">
                                                <tr class="cf-total-row">
                                                    <td v-if="vcolg.libelle"><strong>SOUS-TOTAL</strong></td>
                                                    <td v-if="vcolg.nbmouvements"></td>
                                                    <td v-if="vcolg.qtite"></td>
                                                    <td v-if="vcolg.mtachat" class="text-center" style="text-align:center"><strong>{{ fmt(globaltotaux.mtachat) }}</strong></td>
                                                    <td v-if="vcolg.mtvente" class="text-center" style="text-align:center"><strong>{{ fmt(globaltotaux.mtvente) }}</strong></td>
                                                    <td v-if="vcolg.marge" class="text-center" style="text-align:center"><strong>{{ fmt(globaltotaux.marge) }}</strong></td>
                                                </tr>
                                            </tfoot>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>



                        <div v-if="activetab==='detail'" class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <nav aria-label="Page navigation">
                                        <ul class="ti-pagination mb-0">
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page <= 1 }" class="page-link px-3 py-[0.375rem]" @click="page--">Previous</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link px-3 py-[0.375rem]" :class="{ 'active': pageNumber === page }"
                                                        :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                                    {{ pageNumber }}
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page >= pages.length }" class="page-link px-3 py-[0.375rem]" @click="page++">Next</button>
                                            </li>
                                        </ul>
                                    </nav>




                                </div>
                            </div>
                        </div>
                    </div>





                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print4" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Aperçu avant impression</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <div class="row" v-show="false">

        <div id="invoice">
            <page id="printOrder-dataarticlesparmouvement" ref="printorderdataarticlesparmouvement" class="my-5 page printOrder-data " :size="taillemodel">


                <div   class="my-5 page printOrder-data pagebreak"  >



                    <div class="p-5">

                        <section class="top-content mb-5 bb d-flex justify-content-between">
                            <div class="logo">
                                <img v-if="$store.state.etatlogo" :src="$store.state.etatlogo" alt="" class="img-fluid">
                            </div>
                            <div class="top-left">
                                <div class="logo">

                                </div>
                            </div>
                        </section>

                        <section class="mt-5">
                            <div class="row">

                                <div class="col-6">
                                    <table class="table table-bordered">
                                        <tbody >

                                        <tr>
                                            <td >Raison Social : {{$store.state.etatraisonsocial}}</td>
                                        </tr>
                                        <tr>
                                            <td >Ifu : {{$store.state.etatifu}} /  RC N° RCCM: {{$store.state.etatrccm}} </td>
                                        </tr>
                                        <tr>
                                            <td >Téléphone : {{$store.state.etattelephone}} / {{$store.state.etatadresse}}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-6 ">


                                    <table class="table table-bordered w-full">
                                        <tbody >
                                        <tr>
                                            <td style="text-align: center" colspan="7" >ARTICLES PAR MOUVEMENT DE STOCK — {{ activetab==='detail'?'DETAIL':'GLOBAL' }}</td>

                                        </tr>

                                        <tr >
                                            <td colspan="7" style="text-align: center">Imprimer par :{{$store.state.appusername}} / Imprimer le {{$store.state.appserverdate}}</td>
                                        </tr>



                                        </tbody>
                                    </table>


                                </div>

                            </div>

                        </section>


                        <section   class="product-area mt-3">

                            <table v-if="activetab==='detail'" class="relative w-full border table table-bordered mytable table-hover whitespace-nowrap min-w-full">
                                <thead>
                                <tr>
                                    <th v-if="vcol.docdate" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">DATE</th>
                                    <th v-if="vcol.typdoc" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">TYPE MOUVEMENT</th>
                                    <th v-if="vcol.docref" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">N°DOC</th>
                                    <th v-if="vcol.libelle" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">ARTICLE</th>
                                    <th v-if="vcol.stck_init" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">STOCK AVANT</th>
                                    <th v-if="vcol.qtite" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">QTE</th>
                                    <th v-if="vcol.sctk_final" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">STOCK APRES</th>
                                    <th v-if="vcol.pachat" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">PRIX ACHAT</th>
                                    <th v-if="vcol.pvente" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">PU</th>
                                    <th v-if="vcol.mtachat" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MONTANT ACHAT</th>
                                    <th v-if="vcol.mtvente" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MONTANT VENTE</th>
                                    <th v-if="vcol.marge" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MARGE</th>
                                    <th v-if="vcol.saisiepar" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">SAISI PAR</th>
                                    <th v-if="vcol.enregistrele" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">ENREGISTRÉ LE</th>

                                </tr>
                                </thead>
                                <tbody>

                                <template v-if="filterdatatable.length">

                                    <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                        <td v-if="vcol.docdate"  data-label="DATE  : "   >{{ datavalue.docdate }}</td>
                                        <td v-if="vcol.typdoc"  data-label="TYPE MOUVEMENT  : "   >{{ typeLabel(datavalue.typdoc) }}</td>
                                        <td v-if="vcol.docref"  data-label="N°DOC  : "   >{{ datavalue.docref }}</td>
                                        <td v-if="vcol.libelle"  data-label="ARTICLE  : "   >{{ datavalue.libelle }}</td>
                                        <td v-if="vcol.stck_init" class="text-center" style="text-align: center"  data-label="STOCK AVANT : "   >{{ datavalue.stck_init }}</td>
                                        <td v-if="vcol.qtite" class="text-center" style="text-align: center"  data-label="QTE : "   >{{ datavalue.qtite }}</td>
                                        <td v-if="vcol.sctk_final" class="text-center" style="text-align: center"  data-label="STOCK APRES : "   >{{ datavalue.sctk_final }}</td>
                                        <td v-if="vcol.pachat" class="text-center" style="text-align: center"  data-label="PRIX ACHAT : "   >{{ fmt(datavalue.pachat) }}</td>
                                        <td v-if="vcol.pvente" class="text-center" style="text-align: center"  data-label="PU : "   >{{ fmt(datavalue.pvente) }}</td>
                                        <td v-if="vcol.mtachat" class="text-center" style="text-align: center"  data-label="MONTANT ACHAT : "   >{{ fmt(datavalue.pachat*datavalue.qtite) }}</td>
                                        <td v-if="vcol.mtvente" class="text-center" style="text-align: center"  data-label="MONTANT VENTE : "   >{{ fmt(datavalue.pvente*datavalue.qtite) }}</td>
                                        <td v-if="vcol.marge" class="text-center" style="text-align: center"  data-label="MARGE : "   >{{ fmt((datavalue.pvente-datavalue.pachat)*datavalue.qtite) }}</td>
                                        <td v-if="vcol.saisiepar"  data-label="SAISI PAR  : "   >{{ datavalue.saisiepar }}</td>
                                        <td v-if="vcol.enregistrele"  data-label="ENREGISTRÉ LE  : "   >{{ datavalue.enregistrele }}</td>

                                    </tr>



                                </template>


                                <template v-else>
                                    <tr >
                                        <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                    </tr>

                                </template>



                                </tbody>
                                <tfoot v-if="filterdatatable.length">
                                    <tr>
                                        <td v-if="vcol.docdate"></td>
                                        <td v-if="vcol.typdoc"></td>
                                        <td v-if="vcol.docref"></td>
                                        <td v-if="vcol.libelle"><strong>SOUS-TOTAL</strong></td>
                                        <td v-if="vcol.stck_init"></td>
                                        <td v-if="vcol.qtite"></td>
                                        <td v-if="vcol.sctk_final"></td>
                                        <td v-if="vcol.pachat"></td>
                                        <td v-if="vcol.pvente"></td>
                                        <td v-if="vcol.mtachat" class="text-center" style="text-align:center"><strong>{{ fmt(totaux.mtachat) }}</strong></td>
                                        <td v-if="vcol.mtvente" class="text-center" style="text-align:center"><strong>{{ fmt(totaux.mtvente) }}</strong></td>
                                        <td v-if="vcol.marge" class="text-center" style="text-align:center"><strong>{{ fmt(totaux.marge) }}</strong></td>
                                        <td v-if="vcol.saisiepar"></td>
                                        <td v-if="vcol.enregistrele"></td>
                                    </tr>
                                </tfoot>
                            </table>

                            <table v-else class="relative w-full border table table-bordered mytable table-hover whitespace-nowrap min-w-full">
                                <thead>
                                <tr>
                                    <th v-if="vcolg.libelle" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">ARTICLE</th>
                                    <th v-if="vcolg.nbmouvements" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">NB MOUVEMENTS</th>
                                    <th v-if="vcolg.qtite" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">QTE</th>
                                    <th v-if="vcolg.mtachat" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MONTANT ACHAT</th>
                                    <th v-if="vcolg.mtvente" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MONTANT VENTE</th>
                                    <th v-if="vcolg.marge" scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MARGE</th>

                                </tr>
                                </thead>
                                <tbody>

                                <template v-if="globaldatatable.length">

                                    <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in globaldatatable" :key="index">

                                        <td v-if="vcolg.libelle"  data-label="ARTICLE  : "   >{{ datavalue.libelle }}</td>
                                        <td v-if="vcolg.nbmouvements" class="text-center" style="text-align: center"  data-label="NB MOUVEMENTS : "   >{{ datavalue.nbmouvements }}</td>
                                        <td v-if="vcolg.qtite" class="text-center" style="text-align: center"  data-label="QTE : "   >{{ datavalue.qtite }}</td>
                                        <td v-if="vcolg.mtachat" class="text-center" style="text-align: center"  data-label="MONTANT ACHAT : "   >{{ fmt(datavalue.mtachat) }}</td>
                                        <td v-if="vcolg.mtvente" class="text-center" style="text-align: center"  data-label="MONTANT VENTE : "   >{{ fmt(datavalue.mtvente) }}</td>
                                        <td v-if="vcolg.marge" class="text-center" style="text-align: center"  data-label="MARGE : "   >{{ fmt(datavalue.marge) }}</td>

                                    </tr>



                                </template>


                                <template v-else>
                                    <tr >
                                        <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                    </tr>

                                </template>



                                </tbody>
                                <tfoot v-if="globaldatatable.length">
                                    <tr>
                                        <td v-if="vcolg.libelle"><strong>SOUS-TOTAL</strong></td>
                                        <td v-if="vcolg.nbmouvements"></td>
                                        <td v-if="vcolg.qtite"></td>
                                        <td v-if="vcolg.mtachat" class="text-center" style="text-align:center"><strong>{{ fmt(globaltotaux.mtachat) }}</strong></td>
                                        <td v-if="vcolg.mtvente" class="text-center" style="text-align:center"><strong>{{ fmt(globaltotaux.mtvente) }}</strong></td>
                                        <td v-if="vcolg.marge" class="text-center" style="text-align:center"><strong>{{ fmt(globaltotaux.marge) }}</strong></td>
                                    </tr>
                                </tfoot>
                            </table>


                        </section>

                        <section class="balance-info">
                            <div class="row">

                            </div>
                        </section>
                        <section class="balance-info mt-3">
                            <div class="row">

                            </div>
                        </section>



                    </div>





                </div>


            </page>

        </div>

    </div>


</template>

<script>


    const axios =require('axios');


    import {currentDateTime, randomString, ExportExcel, impression} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "modalrapportarticlesparmouvement",

        watch: {

            searchword: function(newvalue,oldvalue){

                this.page=1

            },

        },


        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },

            filterdatatablebase(){

                let mvalue=this.datatable;

                if (this.searchword!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {
                        return  post.libelle.toLowerCase().includes(t.searchword.toLowerCase())
                    })

                }

                return mvalue;
            },

            filterdatatable(){

                this.perPage=this.DefaultperPage;

                return this.paginate(this.filterdatatablebase) ;
            },

            globaldatatable(){

                let $base= this.filterdatatablebase;

                let $groupes={};

                for (const $ligne of $base){

                    let $key=($ligne.reference!==''?$ligne.reference:$ligne.libelle);

                    if (!$groupes[$key]){
                        $groupes[$key]={
                            libelle:$ligne.libelle,
                            nbmouvements:0,
                            qte_entre:0,
                            qte_sorti:0,
                            qtenette:0,
                            qtite:0,
                            mtachat:0,
                            mtvente:0,
                            marge:0,
                        }
                    }

                    $groupes[$key].nbmouvements++;
                    $groupes[$key].qtite+=$ligne.qtite;
                    $groupes[$key].mtachat+=($ligne.pachat||0)*($ligne.qtite||0);
                    $groupes[$key].mtvente+=($ligne.pvente||0)*($ligne.qtite||0);
                    $groupes[$key].marge=$groupes[$key].mtvente-$groupes[$key].mtachat;
                   /* $groupes[$key].qte_entre+=$ligne.qte_entre;
                    $groupes[$key].qte_sorti+=$ligne.qte_sorti;
                    $groupes[$key].qtenette=$groupes[$key].qte_entre-$groupes[$key].qte_sorti;*/

                }

                return Object.values($groupes).sort(function (a,b) {
                    return a.libelle.localeCompare(b.libelle)
                });
            },

            totaux(){
                let $ta=0,$tv=0;
                for (const $l of this.filterdatatablebase){
                    $ta+=($l.pachat||0)*($l.qtite||0);
                    $tv+=($l.pvente||0)*($l.qtite||0);
                }
                return { mtachat:$ta, mtvente:$tv, marge:$tv-$ta };
            },

            globaltotaux(){
                let $ta=0,$tv=0;
                for (const $g of this.globaldatatable){
                    $ta+=$g.mtachat||0;
                    $tv+=$g.mtvente||0;
                }
                return { mtachat:$ta, mtvente:$tv, marge:$tv-$ta };
            },
        },

        data() {
            return {
                taillemodel:'A4landscape',
                isdisplay:false,
                titlemodal:"",
                activetab:'detail',
                datatable:[],
                datedebut:"",
                datefin:"",

                searchword:'',
                searchtypemouvement:'',

                posts : [''],
                page: 1,
                perPage: 500,
                Defaultpage: 1,
                DefaultperPage: 500,
                pages: [],

                showcolmenu:false,
                detailcols:[
                    {key:'docdate',label:'DATE'},
                    {key:'typdoc',label:'TYPE MOUVEMENT'},
                    {key:'docref',label:'N°DOC'},
                    {key:'libelle',label:'ARTICLE'},
                    {key:'stck_init',label:'STOCK AVANT'},
                    {key:'qtite',label:'QTE'},
                    {key:'sctk_final',label:'STOCK APRES'},
                    {key:'pachat',label:'PRIX ACHAT'},
                    {key:'pvente',label:'PU'},
                    {key:'mtachat',label:'MONTANT ACHAT'},
                    {key:'mtvente',label:'MONTANT VENTE'},
                    {key:'marge',label:'MARGE'},
                    {key:'saisiepar',label:'SAISI PAR'},
                    {key:'enregistrele',label:'ENREGISTRÉ LE'},
                ],
                globalcols:[
                    {key:'libelle',label:'ARTICLE'},
                    {key:'nbmouvements',label:'NB MOUVEMENTS'},
                    {key:'qtite',label:'QTE'},
                    {key:'mtachat',label:'MONTANT ACHAT'},
                    {key:'mtvente',label:'MONTANT VENTE'},
                    {key:'marge',label:'MARGE'},
                ],
                vcol:{
                    docdate:true, typdoc:true, docref:true, libelle:true, stck_init:true,
                    qtite:true, sctk_final:true, pachat:true, pvente:true,
                    mtachat:true, mtvente:true, marge:true, saisiepar:true, enregistrele:true,
                },
                vcolg:{
                    libelle:true, nbmouvements:true, qtite:true,
                    mtachat:true, mtvente:true, marge:true,
                },
            };
        },
        methods: {

            fmt($n){
                let $v=parseFloat($n)||0;
                $v=Math.round($v*100)/100;
                return $v.toLocaleString('fr-FR');
            },

            handleColMenuOutside($event){
                if (!this.showcolmenu){return;}
                let $wrap=this.$el.querySelector('.cf-colmenu-wrap');
                if ($wrap && !$wrap.contains($event.target)){
                    this.showcolmenu=false;
                }
            },

            typeLabel(typdoc){

                let $labels={
                    'ME':"Entrée",
                    'MS':"Sortie",
                    'MI':"Inventaire",
                    'MT':"Transfert",
                }

                return $labels[typdoc]||typdoc;

            },

            ExportExcel(type,name, fn, dl) {
                name=name+"_"+(this.activetab==='detail'?'DETAIL':'GLOBAL')+"_"+currentDateTime()
                var elt = this.activetab==='detail'?this.$refs.exportable_tabledetail:this.$refs.exportable_tableglobal;
                ExportExcel(type,name, fn, dl,elt);

            },



            async print4 () {


                let t=this
                let $style=[];

                let options = {  name: '_blank', }


                if (this.taillemodel==="A4landscape" ){

                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/stylelandscape1.css',
                        process.env.VUE_APP_URL+'print/stylelandscape.css'
                    ]

                }

                if (this.taillemodel==="A4" ){



                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/styleportrait.css',
                        process.env.VUE_APP_URL+'print/styleportraisizebulletin.css'
                    ]

                }


                setTimeout(() => {
                    const printContent = this.$refs.printorderdataarticlesparmouvement.innerHTML;
                    impression(printContent,$style,window.document.title,[],{ format: this.taillemodel })

                }, 500);

            },




            currentDateTime(){
                return currentDateTime
            },


            async load(){

                if (this.datedebut==="" || this.datefin===""){return;}

                this.page=1;
                this.isdisplay=true;

                this.$store.dispatch('lancerchargement',true)


                const t = this;
                let $type=this.searchtypemouvement!==''?this.searchtypemouvement:'all';
                let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/rapport/articlesparmouvement/'+$type+'/'+this.datedebut+'/'+this.datefin+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){


                            t.datatable=[];
                            t.datatable=res.data.mdata.datassuivie;

                            t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];

                        }


                    })
                    .catch((error)=>{
                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            close(){

                this.isdisplay=false;

            },

            show(titlemodal){


                this.titlemodal=titlemodal

                this.datatable=[];
                this.activetab='detail';
                this.searchtypemouvement='';
                this.searchword='';

                this.datedebut=this.$store.state.appserverdate
                this.datefin=this.$store.state.appserverdate

                this.isdisplay=true;

                this.load()



            },





            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

            }



        },
        mounted() {
            document.addEventListener('click',this.handleColMenuOutside);
        },
        beforeUnmount() {
            document.removeEventListener('click',this.handleColMenuOutside);
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .cf-colmenu-wrap { position:relative; }
    .cf-colmenu {
        position:absolute; z-index:50; top:calc(100% + 4px); left:0; min-width:220px;
        max-height:320px; overflow-y:auto; padding:0.5rem;
        background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm);
        box-shadow:var(--cf-shadow-md);
    }
    .cf-colmenu-title { font-size:0.7rem; font-weight:700; letter-spacing:0.03em; color:var(--cf-muted); text-transform:uppercase; padding:0.25rem 0.35rem 0.4rem; }
    .cf-colmenu-item { display:flex; align-items:center; gap:0.5rem; padding:0.3rem 0.35rem; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:0.8rem; color:var(--cf-ink); }
    .cf-colmenu-item:hover { background:var(--cf-surface-alt); }
    .cf-total-row td { background:var(--cf-surface-alt); border-top:2px solid var(--cf-border); font-size:0.82rem; }

    .table td {
        cursor: pointer;
    }

    .h-screen{
        height: 500px!important;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }

        .h-screen,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>
